<template>
  <section>
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title">
        Справочник министерств
      </h1>
      <div class="d-flex flex-row align-start">
        <v-icon
            size="20"
            color="info"
            class="mt-2 mr-2"
        >
          mdi-magnify
        </v-icon>
        <v-text-field
            v-model.lazy="search"
            color="info"
            outlined
            label="Начните набирать наименование министерства"
            class="search-field"
            dense
            style="min-width: 500px"
        />
      </div>
    </div>
    <wrapper-preview-category>
      <grid-table
          :headers="headers.massive"
          :headers-for-rows="headers.massive"
          :num-cols="headers.countCells"
          :loading-data="loading"
          :data-rows="showingServerData"
          type-table="grid"
      >
        <template #region1="{row,cell}">
          <div v-html="cell.template(row)"></div>
          <contact-menu :id="row.id" :props-contact="[]">
            <template #header-title>
              {{ row.name }}
            </template>
          </contact-menu>
        </template>
        <template #actions="{row}">
          <v-btn class="white__v-btn" @click="authAdOrg(row)">Войти</v-btn>
        </template>
      </grid-table>
      <div class="mt-3 d-flex flex-row justify-center align-center">
        <v-autocomplete
            class="pagination-table"
            v-model="userPages"
            :items="pagesPaginate"
            solo
            dense
            filled
            height="25"
            rounded
            style="max-width: 150px"
            @change="changePage($event)"
        ></v-autocomplete>
        <v-pagination
            v-model="page"
            :length="pagesVuetify"
            :total-visible="7"
            @input="changePage($event)"
        >
        </v-pagination>

      </div>
    </wrapper-preview-category>

  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import GridTable from "@/components/GridTable/GridTable";
import ContactMenu from "@/components/Menus/contact-menu";
import config from "@/pages/Admin/configs/founder_config";
import {mapActions, mapGetters} from "vuex";
import {tablePagination} from "@/mixins/tablePagination";
// import UserController from "@/controllers/UserController";

export default {
  name: "Founders",
  components: { ContactMenu, GridTable, WrapperPreviewCategory},
  mixins: [tablePagination],
  data() {
    return {
      search: '',
      headers: config,
      blocking: {value: false, id: null},
    }
  },
  computed: {
    ...mapGetters('spr', {
      getFounders: 'getFounders',
      getFoundersStatus: 'getFoundersStatus',
      getCos: 'getCos',
    }),
    loading() {
      return this.getFoundersStatus
    },
    serverData() {
      return this.getFounders
          .filter(el => !this.search || el.name.toLowerCase().search(this.search.toLowerCase()) !== -1 || String(el.id).toLowerCase().search(this.search.toLowerCase()) !== -1)
          .sort((a, b) => a.id - b.id)
    }
  },
  created() {
    // this.getServerData()
  },
  methods: {
    // ...mapActions('spr', {getRegionsFromServer: 'getRegionsFromServer', changeBlockInfo: 'changeBlockInfo'}),
    ...mapActions('keycloak', {initFakeUser: 'initFakeUser'}),
    ...mapActions('checkFilled', {
      loadingBlockInfo: 'loadingBlockInfo',
      getContact: 'getContact'
    }),

    authAdOrg(row) {
      const isCo = !!this.getCos.find(el => el.id === row.id)
      this.initFakeUser({
        role: isCo ? 'CO_ROLE':'FOUNDER_ROLE',
        id: row.id,
        name: row?.name ?? ''
      });
      if (isCo)
        this.loadingBlockInfo();
      this.getContact('FOUNDER_ROLE');
      this.$router.push({name: 'Accreditation_agreed'})
    }
  },
}
</script>

<style scoped>

</style>